import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import weekday from "dayjs/plugin/weekday";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import utc from "dayjs/plugin/utc";
import i18next from "i18next";
import "dayjs/locale/pl";
import "dayjs/locale/en";

dayjs.extend(relativeTime);
dayjs.extend(weekday);
dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.locale(i18next.language === "pl" ? "pl" : "en");
// Sync Dayjs locale with i18next, including on runtime language changes
const normalizeLocale = (lng?: string) => {
  const base = (lng ?? "").split("-")[0];
  return base === "pl" ? "pl" : "en";
};

const applyLocale = (lng?: string) => {
  dayjs.locale(normalizeLocale(lng));
};

applyLocale(i18next.language);
i18next.on("languageChanged", applyLocale);

export default dayjs;
